<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels" v-loading="loading">
            <slot/>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { saveSignTableLabels } from '../save-sign.js'
const prefixCls = 'pt-save-sign-table'

export default {
  name: 'pt-save-sign-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: null
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableLabels: saveSignTableLabels
    }
  },
  methods: {
    showReTry () {
      this.$refs.table.showReTry()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
